export const config = {
	MERCHANT_CREDENTIALS: {
		SUB_MERCHANT_ID: process.env.REACT_APP_SUB_MERCHANT_ID,
		AUTH_KEY: process.env.REACT_APP_SUB_MERCHANT_AUTH_KEY,
	},
	MERCHANT_URL: window.location.origin,
	SERVER_URL: process.env.REACT_APP_CHECKOUT_API_URL,
};
